

import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle";
import { useState } from "react";
import TopMenus from "../../components/shared/TopMenus";
import MobilePastAiChat from "../../components/aiChatPast/MobilePastAiChat";
import PanelPastAiChat from "../../components/aiChatPast/PanelPastAiChat";
import MobilePastAiChatNewModel from "../../components/aiChatPast/MobilePastAiChatNewModel";
const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    color: ${({theme}) => theme.mainTextColor};
    
    .content{
      margin: 0 30px;
      margin-top: 40px;
      display: flex;
      flex-direction: column;

      .top-container{
        width: 100%;
        padding: 10px 0;
        border-radius: 10px;
        margin-bottom: 30px;

        
      }

      /* .message-container{
        display: flex;
        flex-direction: column;
        gap: 20px;

        .messages-grp{
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 10px;

          .messages-grp-top-container{
            width: 100%;

            h4{
              font-size: var(--font-size-md);
              font-weight: var(--font-weight-lg);
              border-bottom: 2px solid ${({theme}) => theme.mainTextColor};
            }
          }

          .messages-grp-date-grp{
            display: flex;
            flex-direction: column;
            gap: 15px;
          }
        }

    } */


    }
  }
`;

const menulist = [
  {
    id: 1,
    text: "Mobil Yapay Zeka Sohbet Geçmişi (Yeni Model)"
  },
  {
    id: 2,
    text: "Mobil Yapay Zeka Sohbet Geçmişi (Eski Model)"
  },
  {
    id: 3,
    text: "Panel Yapay Zeka Sohbet Geçmişi"
  },
]

const YapayZekaMesajlasmaGecmisi = () => {

    const [activeMenuId, setActiveMenuId] = useState(1)

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Yapay Zeka Mesajlaşma Geçmişi"} position="sticky" />
        <div className="content">
          <div className="top-container">
            <TopMenus menuList={menulist} activeMenuId={activeMenuId} setActiveMenuId={setActiveMenuId}/>
          </div>

          <div className="message-container">

              {
                activeMenuId === 1 && <MobilePastAiChatNewModel/>
              }

              {
                activeMenuId === 2 && <MobilePastAiChat/>
              }

              {
                activeMenuId === 3 && <PanelPastAiChat/>
              }

          </div> 
          </div> 
      </div>
    </Container>
  )
}

export default YapayZekaMesajlasmaGecmisi